import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProjectCopyForm.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { OverlappingBookingsView, VAMtypes } from "../../_loadingHelpers/VAM";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import Edit from '../../../moreCore/UI/Edit/Edit';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";

import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
class EvProjectCopyForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private headingText: HTMLElement;
    private cbEvCast: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvCast: HTMLElement;
    private cbEvProgram: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvProgram: HTMLElement;
    private cbEvService: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvService: HTMLElement;
    private cbEvTask: MdsLax<InstanceType<typeof CheckBox>>;
    private containerEvTask: HTMLElement;
    private inputEvBookings: MdsLax<InstanceType<typeof MultiselectBox>>;
    private inputEvProjectName: MdsLax<InstanceType<typeof Edit>>;
    private inputEvBookingBase: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputDateShiftOriginalDate: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputDateShiftTargetDate: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputArtisticPeriod: MdsLax<InstanceType<typeof SelectBox>>;

    private sectionEvBookingContents: HTMLElement;
    private EvBookingDetailsContainer: HTMLElement;
    private sectionDateShift: HTMLElement;
    private dateShiftInfoContainer: HTMLElement;
    private txtDateShiftInfo: HTMLElement;

    private formData: VAM2types.CopyFormData_EvProject = null;

    private _sourceEvProject: Partial<VAMtypes.EvProjectEntity_Short> = null;

    private _onChange_Any(value?: any) {
        this.delayedSerializeData(50);
    }
    
    private _onChange_DateShiftBooking(value: any) {

        //console.log("_onChange_DateShiftBooking", value);
        let baseBooking: VAMtypes.EvBookingEntity_Short = this.inputEvBookingBase.getValue(true);

        if (baseBooking) {
            this.inputDateShiftOriginalDate.setValue(baseBooking.date_start);

            this.inputDateShiftTargetDate.setReadonly(false);
            this.inputDateShiftTargetDate.setMandatory(true);
        } else {
            this.inputDateShiftOriginalDate.setValue(null);
            this.inputDateShiftTargetDate.setValue(null);
            this.inputDateShiftTargetDate.setReadonly(true);
            this.inputDateShiftTargetDate.setMandatory(false);

            this.calcDateDiff();
        }
    }

    private _onChange_TargetBookings(value: any) {
        //console.log("_onChange_TargetBookings", value);
        
        let bookings = this.inputEvBookings.getValue(true);

        this.hideNode(this.sectionDateShift, bookings.length == 0);
        this.hideNode(this.EvBookingDetailsContainer, bookings.length == 0);
        this.inputDateShiftTargetDate.setMandatory(bookings.length > 0);

        this.delayedSerializeData();
    }
    private _onChange_BaseDate() {
        let value = this.inputDateShiftOriginalDate.getValue();
        //console.log("_onChange_BaseDate", value);

        this.inputDateShiftTargetDate.setValue(value.date);
    }

    private _onChange_TargetDate() {
        let value = this.inputDateShiftTargetDate.getValue();
        //console.log("_onChange_TargetDate", value);

        this.calcDateDiff();

    }

    private calcDateDiff() {
        let firstDate = this.inputDateShiftOriginalDate.getValue().date;
        
        let secondDate = this.inputDateShiftTargetDate.getValue().date;
        
        this.hideNode(this.dateShiftInfoContainer);

        if (firstDate && secondDate) {
            let firstOffset = firstDate.getTimezoneOffset(); // bei uns: -120minuten im Sommer oder -60 normalzeit
            let secondOffset = secondDate.getTimezoneOffset(); // bei uns: -120minuten im Sommer oder -60 normalzeit

            let diffSeconds = (secondDate.getTime() - firstDate.getTime()) / 1000;

            // Sommer-Winterzeit-Offset herausrechnen
            let diffOffset = secondOffset - firstOffset;
            // von Sommer zu Winter: -60 - (-120 ) = 60 (minuten)

            if (diffOffset) diffOffset = diffOffset * 60; // in Sekunden umrechnen

            // die eine Stunde "zu viel" abziehen bzw. Stunde zu wenig dazurechnen:
            diffSeconds = diffSeconds - diffOffset;
            

            this.diffMinutes = diffSeconds / 60;
        } else {
            this.diffMinutes = 0;
        }

        this.delayedSerializeData();

        let diffSeconds = this.diffMinutes * 60;

        let diffDays = 0;
        while (diffSeconds >= 24 * 60 * 60) {
            diffDays++;
            diffSeconds -= 24 * 60 * 60;
        }

        let diffHours = 0;
        while (diffSeconds >= 3600) {
            diffHours++;
            diffSeconds -= 3600;
        }

        let diffMinutes = 0;
        while (diffSeconds >= 60) {
            diffMinutes++;
            diffSeconds -= 60;
        }

        let infoText = this.stringFormat(this.translate("CopyForm__DateShiftAmount_InfoText"),
            diffDays.toString(),
            ("00" + diffHours.toString()).slice(-2),
            ("00" + diffMinutes.toString()).slice(-2));

        this.UiModder.domAttr.set(this.txtDateShiftInfo, "innerHTML", infoText);

        this.hideNode(this.dateShiftInfoContainer, false);
        
    }

    private diffMinutes: number = 0;
    

    private _serializeHandle: any = null;
    private delayedSerializeData(delay: number = 200) {
        if (this._serializeHandle != null) {
            clearTimeout(this._serializeHandle);
            this._serializeHandle = null;
        }

        this._serializeHandle = setTimeout(lang.hitch(this, this.serializeData), delay);
    }
    private serializeData() {
        this._serializeHandle = null;

        if (!this._sourceEvProject) return;

        this.formData = {
            evProjectID: this._sourceEvProject.ID,
            evProjectName: this.inputEvProjectName.getValue(),
            copyEvCast: this.cbEvCast.getValue(),
            copyEvProgram: this.cbEvProgram.getValue(),
            copyEvTasks: this.cbEvTask.getValue(),
            copyEvServiceBookings: this.cbEvService.getValue(),
            targetBookings: this.inputEvBookings.getValue(),
            dateShift: this.diffMinutes,
            artisticPeriodID: this.inputArtisticPeriod.getValue()
        };

       
        this.emit("result", this.validate());
        //console.log("serializeData", this.formData);
    }

    getData() {
        return this.formData;
    }

    private validate(): boolean {
        let result: boolean = true;

        if (!this.inputEvProjectName.validateInput()) result = false;

        if (!this.formData) result = false;

        if (!this.formData.evProjectName) result = false;

        return result;
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<VAMtypes.EvBookingEntity_Short>): boolean {

        let cellname = cell.name;
        
        switch (cellname) {
            //case "actions":
            //    let btn = this.UiModder.domConstruct.create("button", {
            //        className: "mds-button-base round hoverBright deleteBtn",
            //        innerHTML: this.createFontawesomeIcon("fas fa-trash").outerHTML
            //    }, cell.tableCellNode);

            //    on(btn, "click", lang.hitch(this, this._onClick_RemoveDateSet, cell.tableRow.rowGroup.rowIndex));
            //    return true;
            //    break;

            //case "dateStart":
            //    let inputDs = new DateTimeInput();
            //    inputDs.setValue(cell.entity.dateStart, true);
            //    inputDs.placeAt(cell.tableCellNode);

            //    if (cell.entity.isFulltime === true) {
            //        inputDs.useTimeInput(false);
            //    }

            //    on(inputDs, "change", lang.hitch(this, this._onChangeTblCellValue, cell, regEntry));

            //    regEntry.inputDateStart = inputDs;
            //    return true;
            //    break;

           
        }

        return false;
    }

    private _setupArtisticPeriods(entities?: Array<VAM2types.ArtisticPeriod>, presetValue?: string) {
        if (entities) {
            this.inputArtisticPeriod.setBlankOption("", "--", false);

            for (let entity of entities) {
                this.inputArtisticPeriod.addOption(entity.ID, entity.description, typeof (entity.is_active) == "boolean" ? entity.is_active : true);
            }

            this.inputArtisticPeriod.constructOptions();

            if (presetValue) {
                this.inputArtisticPeriod.setValue(presetValue);
            }
        }

        else {
            var url = window.appRoot + "ProjectWizard/GetArtisticPeriod";

            this.hourGlassStart(this.inputArtisticPeriod);

            this.RequestManager.post(
                url,
                {},
                lang.hitch(this, this._onLoadArtisticPeriodResponse, presetValue),
                lang.hitch(this, this._onLoadArtisticPeriodError),
                false // sync
            );
        }
        
    }

    private _onLoadArtisticPeriodResponse(presetValue: string, response: Array<VAM2types.ArtisticPeriod>) {
        
        this.hourGlassEnd(this.inputArtisticPeriod);
        this._setupArtisticPeriods(response, presetValue);
    }

    private _onLoadArtisticPeriodError(error: more.requestErrorMessage) {
        alert("loading artistic periods failed: " + error.Message);
        this.hourGlassEnd(this.inputArtisticPeriod);

    }
    setupWithId(projectID: string) {

        this.StandbyStart();

        this.RequestManager.callfunction("Webtool_API_ProjectWizard__GetDataForCopyform",
            { projectID: projectID },
            lang.hitch(this, this._onGetCopyFormDataResponse),
            lang.hitch(this, function (err: more.requestErrorMessage) {
                this.StandbyStop();
                if (err && err.Message) {
                    alert(err.Message);
                } else {
                    console.log(err);
                }
            }),
            false // commit
        );

    }

    private _onGetCopyFormDataResponse(response: { project: VAMtypes.EvProjectEntity_Short, bookings: Array<VAMtypes.EvBookingEntity_Short> }): void {
        this.StandbyStop();

        this.setup(response.project, response.bookings, null);
    }

    setup(sourceEvProject: VAMtypes.EvProjectEntity_Short, bookings: Array<VAMtypes.EvBookingEntity_Short>,
        availablePeriods?: Array<VAM2types.ArtisticPeriod>) {
        this._sourceEvProject = {
            ID: sourceEvProject.ID,
        };

        this.headingText.innerHTML = sourceEvProject.gDisp_1 ? sourceEvProject.gDisp_1 : "?";

        this.inputEvProjectName.setValue(sourceEvProject.ev_project_name);

        this._setupArtisticPeriods(availablePeriods, sourceEvProject?.ref_artistic_period?.ID);

        let selected = [];
        
        if (!bookings || !bookings.length) {
            this.inputDateShiftTargetDate.setMandatory(false);
        } else {
            this.hideNode(this.sectionDateShift, true);
            this.hideNode(this.sectionEvBookingContents, false);


            bookings.forEach((booking) => {
                selected.push(booking.ID);
            });

            this.inputEvBookings.setData(selected, bookings);

            this.inputEvBookingBase.labelAttribute = "gDisp_1";
            this.inputEvBookingBase.setSelectionListLEGACY(bookings);

        }
        //this.inputEvBookingBase.setValue(selected[0]);

        this.handleAvailableFeatures();
    }

    private handleAvailableFeatures() {

        this.hideNode(this.containerEvCast, !this.hasFeature("EvBooking/EvCast"));
        this.hideNode(this.containerEvProgram, !this.hasFeature("EvBooking/EvProgram"));
        this.hideNode(this.containerEvTask, !this.hasFeature("EvBooking/EvTask"));
        this.hideNode(this.containerEvService, !this.hasFeature("EvBooking/EvService"));

        let module = this.getModule<{
            presets: {
                'EvProgram': boolean
                'EvCast': boolean,
                'EvService': boolean,
                'EvTask': boolean
                /* Hotel und Reise: AH hat gesagt, das kann sowieso nicht sinnvoll gehn - in evis is auch ned drin. lassen wir mal weg inzwischen */ 
            }
        }>("EvProjectCopyform");

        if (module && module.presets) {

            console.debug(this.id + " presets from appsettings", module);

            // unlogisch, die Settings müssen eigentlich aus EvBooking/ kommen, sonst wärs womöglich widersprüchlich
            //this.hideNode(this.containerEvCast, !this.hasFeature("EvBookingCopyform/EvCast"));
            //this.hideNode(this.containerEvProgram, !this.hasFeature("EvBookingCopyform/EvProgram"));
            //this.hideNode(this.containerEvTask, !this.hasFeature("EvBookingCopyform/EvTask"));
            //this.hideNode(this.containerEvService, !this.hasFeature("EvBookingCopyform/EvService"));

            if (typeof (module.presets.EvProgram) == "boolean") {
                this.cbEvProgram.setValue(module.presets.EvProgram);
            }
            if (typeof (module.presets.EvCast) == "boolean") {
                this.cbEvCast.setValue(module.presets.EvCast);
            }
            if (typeof (module.presets.EvService) == "boolean") {
                this.cbEvService.setValue(module.presets.EvService);
            }
            if (typeof (module.presets.EvTask) == "boolean") {
                this.cbEvTask.setValue(module.presets.EvTask);
            }

        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);       
        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProjectCopyForm);